import React, {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router-dom"
import Swal from "sweetalert2";
import axios from 'axios'
import moment from 'moment';
import { NumericFormat } from 'react-number-format';
import { toast } from 'react-toastify';
import fundService from "../../services/fundService";
import ModalViewFund from "./modals/modalViewFund";
import ModalSearchFCI from "./modals/modalSearchFCI";
import ListService from "../../services/listService";
import ModalFCIComments from "./modals/modalFCIComments";   
import ModalFCILogs from "./modals/modalFCILogs";


function ReportFCIBackoffice() {

    const navigate = useNavigate();
    const [sending, setSending] = useState(false)
    const initialized = useRef(false)
    const [listFunds, setListFunds] = useState([])
    const [listFundsLinks, setListFundsLinks] = useState([])
    const [listFundsMeta, setListFundsMeta] = useState([])
    const [modalViewOpen, setModalViewOpen] = useState(false);
    const [fundSelected, setFundSelected] = useState('');
    const userProfile = JSON.parse(sessionStorage.getItem("userProfile"));
    const [modalSearchOpen, setModalSearchOpen] = useState(false);
    const [listAccountManagers, setListAccountManagers] = useState([])
    const [modalCommentsOpen, setModalCommentsOpen] = useState(false);
    const [modalLogsOpen, setModalLogsOpen] = useState(false);

    // Search Form
    let defaultDate = new Date().toISOString().slice(0,10);
    const [searchModel, setSearchModel] = useState({
        account: '',
        status: '',
        dateFrom: defaultDate,
        dateTo: defaultDate,
        acdi: '',
        operationType: '',
        fund: '',
        accountManager: ''
    })

    useEffect(() => {
        //SI ES SORIA SOLO MUESTRA LA CUENTA DE SORIA
        // if(userProfile.id === 105 || userProfile.id === 106){ searchModel.accountManager = 'SORIA, Gonzalo Santiago' }
        if (!initialized.current) {
            initialized.current = true
            // COMERCIAL LOW
            if(userProfile.roleid === 8){ 
                searchModel.accountManager = userProfile.portfolio_manager_id;
            }
            doSearch()
        }
    }, [false]);

    const doSearch = async (event) => {
        try {  
            setSending(true)
            console.log(searchModel)
            const response = await fundService.getFundOperationSearch(searchModel)
            setListFunds(response.data)
            setListFundsLinks(response.links)
            setListFundsMeta(response.meta)
            // Account Managers
            const responseAccountManagers = await ListService.getPortfolioManagersList()
            setListAccountManagers(responseAccountManagers.data)
            setSending(false)
        } catch (e) {
            if (axios.isAxiosError(e)) {
                const statusCode = e.response?.status
                const error = e.response?.data.errors;
                
                if(statusCode && statusCode !== 401){
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            }
            setSending(false)
        }
    }
    
    const doExport = async () => {
        var filters = '';
        if(searchModel.dateFrom !== '' && searchModel.dateFrom !== ""){ filters += '&filter[from]='+searchModel.dateFrom; }
        if(searchModel.dateTo !== '' && searchModel.dateTo !== ""){ filters += '&filter[to]='+searchModel.dateTo; }
        if(searchModel.account !== '' && searchModel.account !== null){ filters += '&filter[account]='+searchModel.account; }
        if(searchModel.status !== '' && searchModel.status !== null){ filters += '&filter[state]='+searchModel.status; }
        if(searchModel.accountManager !== '' && searchModel.accountManager !== null){ filters += '&filter[portfolioManagerId]='+searchModel.accountManager; }
        window.open(process.env.REACT_APP_API_URL+"fund-operations/download/excel?token="+userProfile.token+filters, '_blank')
    }

    const doExportEsco = async () => {
        var filters = '';
        if(searchModel.dateFrom !== '' && searchModel.dateFrom !== ""){ filters += '&filter[from]='+searchModel.dateFrom; }
        if(searchModel.dateTo !== '' && searchModel.dateTo !== ""){ filters += '&filter[to]='+searchModel.dateTo; }
        if(searchModel.account !== '' && searchModel.account !== null){ filters += '&filter[account]='+searchModel.account; }
        if(searchModel.status !== '' && searchModel.status !== null){ filters += '&filter[state]='+searchModel.status; }
        if(searchModel.accountManager !== '' && searchModel.accountManager !== null){ filters += '&filter[portfolioManagerId]='+searchModel.accountManager; }
        window.open(process.env.REACT_APP_API_URL+"fund-operations/download-esco-fci/excel?token="+userProfile.token+filters, '_blank')
    }


    const doView = async (obj) => {
        if(obj !== null){
            setFundSelected(obj)
            setModalViewOpen(true)
        }
    }

    const doEditOpe = async (obj) => {
        if(obj !== null){
            navigate('/funds/'+obj.id)
        }
    }

    const doCancelOpe = async (obj) => {
        Swal.fire({
            title: 'Atención!',
            text: '¿Estás seguro de querer cancelar la operación?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: "Continuar",
            confirmButtonColor: "#83766d"
        })
        .then((result) => {
            if (result.isConfirmed) {
                fundService.putFundStatus(obj.id, {operation_state_id: 4})
                    .then((response) => {
                        toast.success('Operación Cancelada!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        doSearch()
                    })
                    .catch((error) => {
                        if(error.response.status !== 401){
                            Swal.fire({
                                title: 'Ooops?',
                                text: error.response.data.errors[0].detail,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#f13939'
                            })
                        }else{
                            sessionStorage.removeItem("userProfile");
                            navigate('/')
                            window.location.reload();
                        }
                    })
            }
        })
    }

    const doCancelSend = async (obj) => {
        Swal.fire({
            title: 'Atención!',
            text: '¿Ud. esta seguro que quiere RECHAZAR el envio realizado',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: "Continuar",
            confirmButtonColor: "#83766d"
        })
        .then((result) => {
            if (result.isConfirmed) {
                fundService.putFundStatus(obj.id, {fund_operation_status_id: 4})
                    .then((response) => {
                        toast.success('Operación Cancelada!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        doSearch()
                    })
                    .catch((error) => {
                        if(error.response.status !== 401){
                            Swal.fire({
                                title: 'Ooops?',
                                text: error.response.data.errors[0].detail,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#f13939'
                            })
                        }else{
                            sessionStorage.removeItem("userProfile");
                            navigate('/')
                            window.location.reload();
                        }
                    })
            }
        })
    }

    const doCancelStatusSend = async (obj) => {
        Swal.fire({
            title: 'Atención!',
            text: '¿Ud. esta seguro que quiere RECHAZAR el envio realizado',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: "Continuar",
            confirmButtonColor: "#83766d"
        })
        .then((result) => {
            if (result.isConfirmed) {
                fundService.putFundAuthStatusManualReject(obj.id)
                    .then((response) => {
                        toast.success('Operación Rechazada!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        doSearch()
                    })
                    .catch((error) => {
                        if(error.response.status !== 401){
                            Swal.fire({
                                title: 'Ooops?',
                                text: error.response.data.errors[0].detail,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#f13939'
                            })
                        }else{
                            sessionStorage.removeItem("userProfile");
                            navigate('/')
                            window.location.reload();
                        }
                    })
            }
        })
    }

    const doApprovedSend = async (obj) => {
        Swal.fire({
            title: 'Atención!',
            text: '¿Ud. esta seguro que quiere APROBAR el envio realizado',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: "Continuar",
            confirmButtonColor: "#83766d"
        })
        .then((result) => {
            if (result.isConfirmed) {
                fundService.putFundAuthStatusManualApprove(obj.id)
                    .then((response) => {
                        toast.success('Operación Aprobada!', {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        })
                        doSearch()
                    })
                    .catch((error) => {
                        if(error.response.status !== 401){
                            Swal.fire({
                                title: 'Ooops?',
                                text: error.response.data.errors[0].detail,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                confirmButtonColor: '#f13939'
                            })
                        }else{
                            sessionStorage.removeItem("userProfile");
                            navigate('/')
                            window.location.reload();
                        }
                    })
            }
        })
    }

    const doModalComments = async (obj) => {
        if(obj !== null){
            setFundSelected(obj)
            setModalCommentsOpen(true)
        }
    }
    
    const doModalLogs = async (obj) => {
        if(obj !== null){
            setFundSelected(obj)
            setModalLogsOpen(true)
        }
    }
    
    const doPagination = async () => {
        try {  
            setSending(true)
            const response = await fundService.getFundSearchPagination(listFundsLinks.next)
            response.data.forEach( data => listFunds.push(data) )
            setListFundsLinks(response.links)
            setListFundsMeta(response.meta)
            setSending(false)
        } catch (e) {
            if (axios.isAxiosError(e)) {
                const statusCode = e.response?.status
                const error = e.response?.data.errors;
                
                if(statusCode && statusCode !== 401){
                    Swal.fire({
                        title: 'ERROR',
                        text: error[0].detail,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        confirmButtonColor: '#f13939'
                    })
                }else{
                    sessionStorage.removeItem("userProfile");
                    navigate('/')
                    window.location.reload();
                }
            }
            setSending(false)
        }
    }
    
    const doOpenModalSeacht = async () => {
        setModalSearchOpen(true)
    }

    return (
        <>
            <div className="row mb-3">
                <div className="col">
                    <h2>Reporte Operaciones de Fondos { listFundsMeta.total > 0 && <span className="fontMedium">({listFundsMeta.total})</span> }</h2>
                </div>
                <div className="col">
                    <div className="btn-group float-end" role="group" aria-label="First group">
                        <button type="button" className="btn btn-outline-secondary" title="Exportar" onClick={doExport}>
                            <i className="tf-icons bx bx-export" />
                        </button>
                        <button type="button" className="btn btn-outline-secondary" title="Exportar ESCO" onClick={doExportEsco}>ESCO</button>
                        <button type="button" className="btn btn-outline-secondary" title="Buscar" onClick={doOpenModalSeacht } >
                            <i className="tf-icons bx bx-filter" />
                        </button>
                    </div>
                </div>
            </div>

            <div className="row">
                {/* <Sheet sx={{ height: 580, overflow: 'auto', backgroundColor: 'transparent', padding: '2px' }} className="table-responsive"> */}
                    <table className="table table-striped table-hover" >
                        <thead style={{backgroundColor: '#FFFFFF'}}>
                            <tr className="text-nowrap">
                                <th>#</th>
                                <th>Fecha</th>
                                <th>Comintente</th>
                                <th>Fondo</th>
                                {/* <th>Soc. Grt.</th> */}
                                <th>Tipo</th>
                                <th>Cantidad / Monto</th>
                                <th>Oficial</th>
                                <th>Estado</th>
                                <th>Estado Pago</th>
                                <th>Autorización</th>
                                <th>Fecha Envio</th>
                                <th>Fecha Autorización</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody className="table-border-bottom-0">
                            {listFunds.map(fund => {
                                return (
                                    <tr key={fund.id} className="small">  
                                        <td className="small">{fund.id}</td>
                                        {/* <td>
                                            {moment(fund.date).format('DD/MM/YYYY')}
                                            <small className="text-muted">{moment(fund.date).format('HH:MM')}</small>
                                        </td> */}
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            {moment.utc(fund.created_at).format('DD/MM/YYYY')}
                                                        </span>
                                                    </a>
                                                    <small className="text-muted">{moment(fund.created_at).format('HH:mm')}</small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            {fund.account_model.name.length > 30 ?
                                                                `${fund.account_model.name.substring(0, 35)}...` : fund.account_model.name
                                                            }
                                                        </span>
                                                    </a>
                                                    <small className="text-muted"><span className="badge bg-label-dark">{fund.account_model.account}</span></small>
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="d-flex justify-content-start align-items-center user-name">
                                                <div className="d-flex flex-column">
                                                    <a className="text-body text-truncate">
                                                        <span className="fw-medium">
                                                            {fund.fund.name.length > 35 ?
                                                                `${fund.fund.name.substring(0, 35)}...` : fund.fund.name
                                                            }
                                                        </span>
                                                    </a>
                                                    <small className="text-muted">
                                                        {/* {fund.attributes.operation_type_id === 4 && <span className="badge bg-label-primary me-1">{fund.included.operationType.name}</span>} */}
                                                        {/* {fund.attributes.operation_type_id === 3 && <span className="badge bg-label-warning me-1">{fund.included.operationType.name}</span>} */}
                                                        <span className="badge bg-label-primary me-1">{fund.operation_type.name}</span>
                                                        <span className="badge bg-label-info">{fund.currency.name}</span>
                                                        <span className="badge bg-label-dark ms-1">{fund.settlement_term.name}</span>
                                                    </small>
                                                </div>
                                            </div>
                                        </td>
                                        {/* SOCIEDAD GERENTE */}
                                        {/* <td className="text-center"> 
                                            {fund.fund.is_management_company && <span className="badge bg-label-success me-1"><i className="tf-icons bx bx-check" /></span>}
                                            {!fund.fund.is_management_company && <span className="badge bg-label-danger me-1"><i className="tf-icons bx bx-x" /></span>}
                                        </td> */}
                                        <td>{fund.investment_mode.name}</td>
                                        <td className="text-end">
                                            <NumericFormat 
                                                displayType="text" 
                                                value={fund.qty} 
                                                decimalScale={fund.fund.decimals} 
                                                allowLeadingZeros thousandSeparator="." 
                                                decimalSeparator="," 
                                            /> 
                                        </td>
                                        <td className="small">{fund.account_model.portfolio_manager}</td>
                                        <td>
                                            {fund.operation_state_id === 1 && <span className="badge bg-label-secondary me-1">{fund.operation_state.display_name}</span>}
                                            {fund.operation_state_id === 2 && <span className="badge bg-label-warning me-1">{fund.operation_state.display_name}</span>}
                                            {fund.operation_state_id === 3 && <span className="badge bg-label-success me-1">{fund.operation_state.display_name}</span>}
                                            {fund.operation_state_id === 4 && <span className="badge bg-label-danger me-1">{fund.operation_state.display_name}</span>}
                                            {fund.operation_state_id === 5 && <span className="badge bg-label-secondary me-1">{fund.operation_state.display_name}</span>}
                                        </td>
                                        <td>
                                            {fund.operation_type_id === 4 &&  fund.is_acdi ?
                                                <span>
                                                    {fund.fund_payment_status_id === 1 && <span className="badge bg-label-success me-1">Pendientes</span>}
                                                    {fund.fund_payment_status_id === 2 && <span className="badge bg-label-warning me-1">Pagado</span>}
                                                    {fund.fund_payment_status_id === 3 && <span className="badge bg-label-danger me-1">Cancalado</span>}
                                                </span>
                                            : null }
                                        </td>
                                        <td>
                                            <>
                                                {fund.fund_operation_status_id === 1 && <span className="badge bg-label-secondary me-1">{fund.fund_operation_status.display_name}</span>}
                                                {fund.fund_operation_status_id === 2 && <span className="badge bg-label-info me-1">{fund.fund_operation_status.display_name}</span>}
                                                {fund.fund_operation_status_id === 3 && <span className="badge bg-label-primary me-1">{fund.fund_operation_status.display_name}</span>}
                                                {fund.fund_operation_status_id === 4 && <span className="badge bg-label-danger me-1">{fund.fund_operation_status.display_name}</span>}
                                                {fund.fund_operation_status_id === 5 && <span className="badge bg-label-info me-1">{fund.fund_operation_status.display_name}</span>}
                                                {fund.fund_operation_status_id === 6 && <span className="badge bg-label-success me-1">{fund.fund_operation_status.display_name}</span>}
                                                {fund.fund_operation_status_id === 7 && <span className="badge bg-label-secondary me-1">{fund.fund_operation_status.display_name}</span>}
                                                {fund.fund_operation_status_id === 8 && <span className="badge bg-label-danger me-1">{fund.fund_operation_status.display_name}</span>}
                                                {fund.fund_operation_status_id === 9 && <span className="badge bg-label-secondary me-1">{fund.fund_operation_status.display_name}</span>}
                                            </>
                                        </td>
                                        <td onClick={() => {  doModalLogs(fund) }}>{fund.sent_at !== null && moment(fund.sent_at).format('DD/MM/YYYY HH:mm')}</td>
                                        <td>{fund.signed_at !== null && moment(fund.signed_at).format('DD/MM/YYYY HH:mm')}</td>
                                        <td className="text-end">
                                            <div className="dropdown">
                                                <button type="button" className="btn p-0 dropdown-toggle hide-arrow" data-bs-toggle="dropdown">
                                                    <i className="bx bx-dots-vertical-rounded" />
                                                </button>
                                                <div className="dropdown-menu">
                                                    <a className="dropdown-item" href="javascript:void(0);"  onClick={() => {  doView(fund) } }>Ver</a>
                                                    <a className="dropdown-item" href="javascript:void(0);"  onClick={() => {  doModalComments(fund) } }>Comenterios</a>
                                                    {fund.operation_state_id === 1 && 
                                                        <>
                                                            <a className="dropdown-item" href="javascript:void(0);"  onClick={() => {  doEditOpe(fund) } }>Editar</a>
                                                            <a className="dropdown-item" href="javascript:void(0);"  onClick={() => {  doCancelOpe(fund) } }>Cancelar</a>
                                                        </>
                                                    }
                                                    {userProfile.role === 1 && fund.fund_operation_status_id === 2 && 
                                                        <a className="dropdown-item" href="javascript:void(0);"  onClick={() => {  doCancelSend(fund) } }>Rechazar Envio</a>
                                                    }
                                                    {/* SOLO PARA SOCIEDADES GERENTES */}
                                                    {fund.fund_operation_status_id === 7 && 
                                                    <>
                                                        <a className="dropdown-item" href="javascript:void(0);"  onClick={() => {  doApprovedSend(fund) } }>Aprobar</a>
                                                        <a className="dropdown-item" href="javascript:void(0);"  onClick={() => {  doCancelStatusSend(fund) } }>Rechazar</a>
                                                    </>
                                                    }
                                                </div>
                                            </div>
                                        </td>
                                        
                                    </tr>
                                    )
                                })
                            }

                        </tbody>
                    </table>
                {/* </Sheet> */}
            </div>
            { listFundsLinks.next !== null ?
                    <div className="row mt-4">
                        <div className="col d-grid gap-2 d-md-flex justify-content-md-center">
                        { sending ? 
                            <div className="d-flex justify-content-center">
                                <div className="spinner-border text-info" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </div>
                        : 
                            <button type="button" className="btn btn-outline-info" onClick={doPagination}>Mas Información</button>
                        }
                        </div>
                    </div>
                :
                    null
            }
            
            {/* SEARCH */}
            <ModalSearchFCI
                handleOpen={setModalSearchOpen} 
                isOpen={modalSearchOpen} 
                setSearch={setSearchModel}
                search={searchModel}
                doSearch={doSearch}
                listComerciales={listAccountManagers}
            />
            
            { fundSelected !== '' ?
                <>
                <ModalViewFund 
                    handleOpen={setModalViewOpen} 
                    isOpen={modalViewOpen} 
                    selected={fundSelected}
                    fundId={fundSelected.id}
                />

                <ModalFCIComments 
                    handleOpen={setModalCommentsOpen} 
                    isOpen={modalCommentsOpen} 
                    selected={fundSelected}
                    handleSelected={setFundSelected}
                    fundId={fundSelected.id}
                    doSearch={doSearch}
                />
                
                <ModalFCILogs
                    handleOpen={setModalLogsOpen} 
                    isOpen={modalLogsOpen} 
                    arrayLogs={fundSelected.fund_operation_mail_logs}
                    fundId={fundSelected.id}
                />
                </>
            :
                null
            }

        </>
     );

}

export default ReportFCIBackoffice;